import { Component } from '@angular/core';
import { StatusService } from '../status.service';
import { Status } from '../status';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-status-edit',
  templateUrl: 'edit.component.html',
})
export class StatusEditComponent {
  /**
   * Details of the status being edited.
   */
  public status: Status;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {StatusService} statusService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private statusService: StatusService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.statusService.loading.subscribe(result => (this.isLoading = result));
    this.route.params.subscribe(params => this.loadStatus(params.id));
  }

  /**
   * Perform the edit action which send the edited status to the backend.
   */
  public edit() {
    const editStatus = this.statusService
      .updateStatus(this.status.id, this.status)
      .subscribe(
        (result: Status) => {
          this.notificationService.success(
            `Status Updated`,
            `The status ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.status = new Status();
          editStatus.unsubscribe();
          this.router.navigate(['/statuses']);
        },
        err => {
          this.notificationService.error(
            `Status Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/statuses']);
        },
      );
  }

  /**
   * Loads the requested status so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadStatus(id: string) {
    this.statusService.findStatus(id).subscribe(
      result => {
        this.status = result;
      },
      err => {
        this.notificationService.error(
          `Status Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/statuses']);
      },
    );
  }
}
